import React, { useEffect, Suspense } from 'react';
import { Router, Route, Switch, useLocation } from 'react-router-dom'
import { connect } from 'react-redux';
import { createBrowserHistory } from "history";
import { AppLayout, BlankLayout, SimpleLayout } from './layouts';
import {
    TransfersList,
    ManageSSO,
    Dashboard,
    ContactList,
    LedgerList,
    BulkOperations,
    MerchantList,
    InvoiceList,
    APIRequestsList,
    ReportList,
    PayoutLinkList,
    PayoutLinkPaymentAttempt,
    Exceptions,
    UserList,
    TallyInvoiceList,
    TransferRequestApprovalList,
    ApproveTransferRequestForm,
    ResetPassword,
    VendorsList,
    VendorInvoiceList,
    Laas
} from './components';
import MerchantLogin from './components/Merchants/Login';
import Settings from './components/Settings';
import SmartCollect from './components/SmartCollect';
import VATransactions from './components/SmartCollect/transactions'
import Disbursements from './components/SmartCollect/disbursements'
import Ledger from './components/SmartCollect/ledger'
import 'antd/dist/antd.css';
import './assets/bootstrap-v4/bootstrap.min.css';
import './ant-overwrite.scss';
import './App.scss';
import ApprovalsList from './components/VendorPayouts/Approvals/List';
import { GST, DirectTax } from './components/TaxPayments';
import { fetchSiteVersion } from './utilities/siteVersionUtil';


const customHistory = createBrowserHistory();

const redirect = (to, onRouteChange = () => { }, e) => {
    customHistory.push(to);
    typeof onRouteChange === "function" ? onRouteChange() : e = onRouteChange;
}

const AppRouteHoc = ({ component: Component, layout: Layout, ...rest }) => {
    const location = useLocation();
    return (
        <Route
            {...rest}
            render={props => {
                return (
                    <Layout history={customHistory} isPublic={rest.isPublic} redirect={redirect.bind(this)}>
                        <Component {...props} {...rest} redirect={redirect.bind(this)} key={location.pathname}/>
                    </Layout>
                )
            }}
        />
    )
}

const App = (props) => {

    useEffect(() => {
        if (customHistory.location.pathname.indexOf("/login") == -1 && customHistory.location.pathname.indexOf("/disburse") == -1 && customHistory.location.pathname.indexOf("/oops-eh") == -1 && customHistory.location.pathname.indexOf("/approve") == -1 && customHistory.location.pathname.indexOf("/account/password-reset") == -1) {
            if (!props.current_user || !props.current_user.id) {
                customHistory.push(`/app/easebuzz/sso?next=${customHistory.location.pathname}${customHistory.location.search}`);
            }
        }
        fetchSiteVersion();
    }, [])

    return (
        <Router history={customHistory}>
            <div style={{ position: 'relative', height: "100%" }}>
                <Switch>
                    <AppRouteHoc exact path="/app/easebuzz/sso" layout={BlankLayout} component={ManageSSO} pathkey="sso" />
                    <AppRouteHoc exact path="/" layout={AppLayout} component={Dashboard} pathkey="dashboard" />
                    <AppRouteHoc exact path="/tax-payments/gst" layout={AppLayout} component={GST} pathkey="/gst" />
                    <AppRouteHoc exact path="/tax-payments/direct_tax" layout={AppLayout} component={DirectTax} pathkey="/direct_tax" />
                    <AppRouteHoc exact path="/dashboard" layout={AppLayout} component={Dashboard} pathkey="dashboard" />
                    <AppRouteHoc exact path="/contacts" layout={AppLayout} component={ContactList} pathkey="contacts" />
                    <AppRouteHoc exact path="/transfers" layout={AppLayout} component={TransfersList} pathkey="transfers" />
                    <AppRouteHoc exact path="/transfers?contact_id=:contact_id" layout={AppLayout} component={TransfersList} pathkey="transfers" />
                    <AppRouteHoc exact path="/transfers?beneficiary_id=:beneficiary_id:?beneficiary_account_name=:beneficiary_account_name" layout={AppLayout} component={TransfersList} pathkey="transfers" />
                    <AppRouteHoc exact path="/transfers?batch_id=:batch_id" layout={AppLayout} component={TransfersList} pathkey="transfers" />
                    <AppRouteHoc exact path="/ledger" layout={AppLayout} component={LedgerList} pathkey="ledger" />
                    <AppRouteHoc exact path="/batches" layout={AppLayout} component={BulkOperations} pathkey="batches" />
                    <AppRouteHoc exact path="/batches/:batch_type" layout={AppLayout} component={BulkOperations} pathkey="batches" />
                    <AppRouteHoc exact path="/merchants" layout={AppLayout} component={MerchantList} pathkey="merchants" />
                    <AppRouteHoc exact path="/:code/login" layout={BlankLayout} component={MerchantLogin} pathkey="merchants-login" />
                    <AppRouteHoc exact path="/invoices" layout={AppLayout} component={InvoiceList} pathkey="invoices" />
                    <AppRouteHoc exact path="/settings" layout={AppLayout} component={Settings} pathkey="settings" />
                    <AppRouteHoc exact path="/settings/:activeTab" layout={AppLayout} component={Settings} pathkey="settings" />
                    <AppRouteHoc exact path="/utility-requests" layout={AppLayout} component={APIRequestsList} pathkey="utility-requests" />
                    <AppRouteHoc exact path="/reports" layout={AppLayout} component={ReportList} pathkey="reports" />
                    <AppRouteHoc exact path="/laas" layout={AppLayout} component={Laas} pathkey="laas" />
                    <AppRouteHoc exact path="/payout-links" layout={AppLayout} component={PayoutLinkList} pathkey="payout-links" />
                    <AppRouteHoc exact path="/users" layout={AppLayout} component={UserList} pathkey="users" />
                    <AppRouteHoc exact path="/payout-links/:white_label_code/:ulc/disburse" layout={SimpleLayout} component={PayoutLinkPaymentAttempt} pathkey="disburse" />
                    <AppRouteHoc exact path="/oops-eh/:statusCode" layout={BlankLayout} component={Exceptions} pathkey="exceptions" />
                    <AppRouteHoc exact path="/approval-requests/:approval_id/:user_id/approve" layout={SimpleLayout} component={ApproveTransferRequestForm} pathkey="approve_link" />
                    <AppRouteHoc path="/smart-collect" layout={AppLayout} component={SmartCollect} pathkey="insta-collect" />
                    <AppRouteHoc path="/insta-collect" layout={AppLayout} component={SmartCollect} pathkey="insta-collect" />
                    <AppRouteHoc path="/tally-invoices" layout={AppLayout} component={TallyInvoiceList} pathkey="tally-invoice" />
                    <AppRouteHoc path="/vendor-payout/manage" layout={AppLayout} component={VendorsList} pathkey="manage-vendor" />
                    <AppRouteHoc path="/vendor-payout/invoices" layout={AppLayout} component={VendorInvoiceList} pathkey="vendor-invoices" />
                    <AppRouteHoc exact path="/vendor-payout/approvals" layout={AppLayout} component={ApprovalsList} pathkey="approvals" />
                    <AppRouteHoc exact path="/approval-flow" layout={AppLayout} component={TransferRequestApprovalList} pathkey="transfers" />
                    <AppRouteHoc exact path="/account/password-reset/:unique_code" layout={SimpleLayout} component={ResetPassword} pathkey="reset_password_link" />
                    <AppRouteHoc path="*" layout={BlankLayout} component={Exceptions} pathkey="not-found" /> {/* <-- Always keep this at last. */}
                </Switch>
            </div>
        </Router>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

export default connect(mapStateToProps)(App);